import { __assign, __rest } from "tslib";
import * as React from 'react';
export var Tag = function (_a) {
    var label = _a.label, _b = _a.kind, kind = _b === void 0 ? 'default' : _b, children = _a.children, rest = __rest(_a, ["label", "kind", "children"]);
    return (React.createElement("span", __assign({ className: "tag-label tag-label-".concat(kind) }, rest),
        label,
        children));
};
//# sourceMappingURL=index.js.map